export const routes = {
  LOGIN: '/login',
  REGISTER: '/register/:orgId',
  HOME: '/home',
  PROFILE: '/profile/:id',
  SEARCH: '/search',
  GIFT: '/gift',
  EDIT: '/profile-edit',
  ANNOUNCEMENTS: '/announcement',
  ANNOUNCEMENT: '/announcement/:id',
  GIVE_KUDOS: '/give-kudos',
  KUDOS: '/kudos/:id',
  SETTINGS: '/settings',
  CHANGE_PASS: '/settings/change-password',
  SETTINGS_NOTIFICATIONS: '/settings/notification',
  FEEDBACKS: '/conversation',
  USER_CONVERSATIONS: '/conversation/u/:userId',
  FEEDBACK: '/conversation/:id',
  FEEDBACK_REQUEST_CREATE: '/conversation-create',
  NOTIFICATION_LIST: '/notifications',
  MOOD_TRACKER: '/mood-tracker',
  GREETING_MOOD_TRACKER: '/greeting-mood-tracker',
  NOT_FOUND: '/oops',
  WELCOME: '/welcome',
  SURVEYS: '/survey',
  SURVEY: '/survey/:id',
  BIRTHDAY: '/birthday',
  RESETPASSWORD: '/reset-password',
  OCCASIONS: '/occasions'
};

export const publicRoutes = ['LOGIN', 'NOT_FOUND', 'REGISTER', 'RESETPASSWORD'];

export const selectedPaths = (exclude = []) => {
  const res = {};

  for (const route of Object.keys(routes)) {
    if (!exclude.includes(route)) {
      res[route] = routes[route];
    }
  }

  return Object.values(res);
};
